import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiEndpointConfiguration, IMobizHttpService, MobizServerApi, PagedResults } from '../../core';
import { Inject, Injectable } from '../../injection';
import { MobizSettings } from '../data/mobiz-settings.do';
import { MobizSystemSettings, SystemSettings } from '../data/system-settings.do';
import { ISystemSettingsService, SystemSettingsQueryParameters } from '../interfaces/system-settings.interface';
import { MobizSettingsKeySystem } from '../other/mobiz-settings.type';

@Injectable()
export class SystemSettingsService implements ISystemSettingsService {
  constructor(
    @Inject(IMobizHttpService)
    private http: IMobizHttpService,
  ) {
  }

  // TODO: Refactor code to avoid binding and convert to a methods.
  public getAll(
    queryParameters: SystemSettingsQueryParameters = { valueSchema: undefined },
  ): Observable<PagedResults<MobizSettings<SystemSettings>>> {
    const settingsListInstance = new PagedResults<MobizSettings<SystemSettings>>(MobizSystemSettings);

    const config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.SystemSettingsAll,
      queryParameters: queryParameters,
    };

    return this.http.get(settingsListInstance, config).pipe(
      map((response: PagedResults<MobizSettings<SystemSettings>>) => {
        return response;
      }),
    );
  }

  public get(key: MobizSettingsKeySystem): Observable<MobizSettings<SystemSettings>> {
    const settingsInstance = new MobizSettings<SystemSettings>(SystemSettings);

    const config: ApiEndpointConfiguration = {
      serverApi: MobizServerApi.SystemSettings,
      urlParameters: {
        key: key,
      },
    };

    return this.http.get(settingsInstance, config);
  }

  public set(
    key: MobizSettingsKeySystem,
    instance: MobizSettings<SystemSettings>,
  ): Observable<MobizSettings<SystemSettings>> {
    const config: ApiEndpointConfiguration = {
      body: JSON.stringify(instance),
      serverApi: MobizServerApi.SystemSettings,
      urlParameters: {
        key: key,
      },
    };

    if (instance.origin === 'DB') {
      return this.http.put(instance, config);
    }
    return this.http.post(instance, config);
  }
}
